import React from 'react';
import * as Icons from 'lucide-react';
import { featureCards } from '../mock';

const FeatureCards = () => {
  return (
    <section className="bg-white py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl mb-14">
          <p className="text-sm font-semibold text-[#0e9f6e] mb-3">Everything in one app</p>
          <h2 className="font-display text-4xl sm:text-5xl font-700 text-[#0f1712]">One tap to sell. One place to grow.</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featureCards.map((c, i) => {
            const Icon = Icons[c.icon] || Icons.Circle;
            return (
              <div key={i} className="rounded-3xl border border-[#0f1712]/8 bg-[#f6f6f2] p-7 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(15,23,18,0.08)] transition-all duration-300">
                <div className="w-12 h-12 rounded-2xl bg-[#0e9f6e]/12 flex items-center justify-center mb-6">
                  <Icon size={22} className="text-[#0e9f6e]" />
                </div>
                <h3 className="font-display text-lg font-600 text-[#0f1712] mb-2 leading-snug">{c.title}</h3>
                <p className="text-sm text-[#0f1712]/55 leading-relaxed">{c.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeatureCards;
